
import * as React from 'react';

const UserContext = React.createContext();

export const UserProvider = (props) => {
  const { user } = props;

  return (
    <UserContext.Provider value={user} {...props} />
  );
};

export const useUser = () => {
  const user = React.useContext(UserContext);

  if (user === undefined) {
    throw new Error('useUser must be used within a UserProvider');
  }

  return user;
};
